







































































































































































import { Component, Vue, Mixins, Watch } from 'vue-property-decorator'
import Validatable from '@/mixins/Validatable'
import { Getter, Action, Mutation } from 'vuex-class'

import { isEmail, isMobilePhone, isPostalCode } from 'validator'
import { isConfigValid } from '@/service/validators/EshopConfigValidator'

import PageContainer from '@/components/PageContainer.vue'
import ProductList from '@/components/ProductList.vue'
import DiscountBlock from '@/components/DiscountBlock.vue'
import BasketSection from '@/components/BasketSection.vue'

import TextField from '@/components/form/TextField.vue'
import TextArea from '@/components/form/TextArea.vue'
import AgreementBlock from '@/components/form/AgreementBlock.vue'
import DescriptionBlock from '@/components/form/DescriptionBlock.vue'
import DntSendBlock from '@/components/form/DntSendBlock.vue'
import SelectGrid from '@/components/form/SelectGrid.vue'
import ValidationForm from '@/components/form/ValidationForm.vue'
import ErrorMessage from '@/components/ErrorMessage.vue'

import { takeState } from 'vuex-dot'

import Loading from '@/components/services/Loading'

import config from '@/config'
import { Product, Discount, SelectGridOption } from '@/store/types'
import { PaymentGatewayMap, DeliveryOption, SurveyField } from 'proto/eshop/Basket_pb'

import { compose, defaultFormatter, inputFormatter, emailFormatter } from '@/utils/formatters'

@Component({
	components: {
		PageContainer,
		ProductList,
		DiscountBlock,
		BasketSection,
		TextField,
		TextArea,
		AgreementBlock,
		DescriptionBlock,
		DntSendBlock,
		SelectGrid,
		ValidationForm,
		ErrorMessage,
	},
	computed: {
		...takeState('userInfo')
			.expose([
				'fullName',
				'email',
				'phone',
				'postcode',
				'city',
				'address',
				'acceptMarketingMessages',
				'isAgree',
				'dntSendTo3rdParties',
				'paymentOption',
				'deliveryOption',
				'deliveryPrice100',
				'orderComment',
			])
			.commit('updateUserInfo')
			.map(),
	},
})
export default class BasketPage extends Mixins(Vue, Validatable) {
	$refs!: {
		form: ValidationForm
	}

	// FIXME: по какой-то неведомой причине валидация падает на paymentRules и products
	private readonly config = config
	private readonly counterEnabled: boolean = config.productCounterEnabled
	private readonly promocodesEnabled: boolean = config.promocodesEnabled

	private readonly surveyEnabled: boolean = config.surveyEnabled
	private readonly fioEnabled: boolean = config.sfEnabled(SurveyField.FIO)
	private readonly emailEnabled: boolean = config.sfEnabled(SurveyField.MAIL)
	private readonly phoneEnabled: boolean = config.sfEnabled(SurveyField.PHONE)
	private readonly postcodeEnabled: boolean = config.sfEnabled(SurveyField.POSTCODE)
	private readonly cityEnabled: boolean = config.sfEnabled(SurveyField.CITY)
	private readonly addressEnabled: boolean = config.sfEnabled(SurveyField.ADDRESS)
	private readonly acceptMarketingMessagesEnabled: boolean = config.sfEnabled(SurveyField.ACM)
	private readonly dntSendTo3rdPartiesEnabled: boolean = config.sfEnabled(SurveyField.DNTSNDTO3RDPRT) && config.dntSendToThirdParties !== undefined && config.dntSendToThirdParties.label !== undefined && config.dntSendToThirdParties.label.length > 0

	private fullName!: string
	private email!: string
	private phone!: string
	private postcode!: string
	private city!: string
	private address!: string
	private acceptMarketingMessages!: boolean
	private isAgree!: boolean
	private dntSendTo3rdParties!: boolean
	private paymentOption!: ValueOf<PaymentGatewayMap>
	private deliveryOption!: number
	private deliveryPrice100!: number
	private orderComment!: string

	@Mutation private readonly clearUserInfo!: () => void

	@Getter private readonly minDeliveryPrice100!: (delivery: DeliveryOption.AsObject) => number
	@Getter private readonly availableDeliveryOptions!: (payment: ValueOf<PaymentGatewayMap>) => Array<DeliveryOption.AsObject>

	@Action private deleteProduct!: (product: Product) => void
	@Action private placeOrder!: () => Promise<void>
	@Action private validateEmail!: (email: string) => Promise<boolean>

	private get products(): Product[] {
		return this.$store.getters.products
	}

	private get discount(): Discount {
		return this.$store.getters.discount
	}

	private get paymentOptionsList() {
		if (config.deliveryEnabled) {
			const result: SelectGridOption[] = []
			config.paymentOptionsList.forEach(payment => {
				if (this.availableDeliveryOptions(payment.paymentGateway).length) {
					result.push({
						label: payment.name,
						value: payment.paymentGateway,
					})
				}
			})
			return result
		} else {
			// все способы оплаты без ограничений по службе доставки
			return config.paymentOptionsList.map(payment => {
				return {
					label: payment.name,
					value: payment.paymentGateway,
				}
			})
		}
	}

	private get deliveryOptionsList() {
		if (!this.config.deliveryEnabled) return [] // пустой список когда отключен выбор службы доставки
		return this.availableDeliveryOptions(this.paymentOption).map(option => {
			return {
				value: option.id,
				label: option.name,
			}
		})
	}

	private get selectedDelivery() {
		return this.availableDeliveryOptions(this.paymentOption).find(option => {
			return option.id === this.deliveryOption
		})
	}

	// FIXME: fix "this"
	// There is "this" refers to class instead of vue component instance, its breake access to porops
	protected defaultRules = [ () => this.products.length || this.$t('Your shopping cart is empty') ]

	get marketingMessagesLabel() {
		if (!config.acceptMarketingMessages) return null
		return config.acceptMarketingMessages.label
	}

	get marketingMessagesDescription() {
		if (!config.acceptMarketingMessages) return null
		return config.acceptMarketingMessages.description
	}

	get emailAsyncRules() {
		return [ async (value: string) => await this.validateEmail(value) || this.$t('Invalid e-mail address') ]
	}

	get emailRules() {
		return [ (value: string) => isEmail(value) || this.$t('Invalid e-mail address') ]
	}

	get phoneRules() {
		return [ (value: string) => isMobilePhone(value) || this.$t('Invalid phone number') ]
	}

	get postcodeRules() {
		return [ (value: string) => isPostalCode(value, 'any') || this.$t('Invalid zip code') ]
	}

	get agreementRules() {
		return [
			(value: boolean) => value || this.$t('You must accept the terms to continue'),
		]
	}

	get paymentRules() {
		return [
			(gateway: ValueOf<PaymentGatewayMap>) => {
				return config.paymentOptionsList.some((payment) => payment.paymentGateway === gateway) || this.$t('Please select a payment method')
			},
		]
	}

	get deliveryRules() {
		return [
			(val: number) => this.deliveryOptionsList.some(({ value }) => val === value) || this.$t('Please select a delivery method'),
		]
	}

	private get showConfigError() {
		return !isConfigValid(config)
	}

	@Watch('products')
	private onProductListChanged(products: Product[]) {
		if (products.length) this.validate()
	}

	@Watch('selectedDelivery')
	private onDeliveryChanged() {
		let result = 0
		if (this.selectedDelivery) {
			result = this.minDeliveryPrice100(this.selectedDelivery)
		}
		this.deliveryPrice100 = result
	}

	private async onSubmit() {
		const isValid = await this.validate()
		if (!isValid) return

		Loading.show()
		try {
			await this.placeOrder()
			this.$refs.form.resetValidation()
			this.$refs.form.reset()
		} finally {
			Loading.hide()
		}
	}

	private onDelete(product: Product) {
		this.deleteProduct(product)
	}

	private defaultFormatter = defaultFormatter
	private inputFormatter = inputFormatter
	private emailFormatter = emailFormatter
	private compose = compose
}
